__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerSignUpContent-module-scss-module__QRUmqq__accordionSlideOverwrite",
  "fadeIn": "partnerSignUpContent-module-scss-module__QRUmqq__fadeIn",
  "fadeOut": "partnerSignUpContent-module-scss-module__QRUmqq__fadeOut",
  "footer": "partnerSignUpContent-module-scss-module__QRUmqq__footer",
  "footerDecoration": "partnerSignUpContent-module-scss-module__QRUmqq__footerDecoration",
  "footerDecorationDesktop": "partnerSignUpContent-module-scss-module__QRUmqq__footerDecorationDesktop",
  "footerDecorationMobile": "partnerSignUpContent-module-scss-module__QRUmqq__footerDecorationMobile",
  "header": "partnerSignUpContent-module-scss-module__QRUmqq__header",
  "layoutContainer": "partnerSignUpContent-module-scss-module__QRUmqq__layoutContainer",
  "loginLink": "partnerSignUpContent-module-scss-module__QRUmqq__loginLink",
  "logo": "partnerSignUpContent-module-scss-module__QRUmqq__logo",
  "logoCompact": "partnerSignUpContent-module-scss-module__QRUmqq__logoCompact",
  "logoDefault": "partnerSignUpContent-module-scss-module__QRUmqq__logoDefault",
  "logoWrapper": "partnerSignUpContent-module-scss-module__QRUmqq__logoWrapper",
  "main": "partnerSignUpContent-module-scss-module__QRUmqq__main",
  "pageWrapper": "partnerSignUpContent-module-scss-module__QRUmqq__pageWrapper",
  "scaleIn": "partnerSignUpContent-module-scss-module__QRUmqq__scaleIn",
  "scaleOut": "partnerSignUpContent-module-scss-module__QRUmqq__scaleOut",
  "subtitle": "partnerSignUpContent-module-scss-module__QRUmqq__subtitle",
  "title": "partnerSignUpContent-module-scss-module__QRUmqq__title",
  "verificationMain": "partnerSignUpContent-module-scss-module__QRUmqq__verificationMain",
  "welcomeText": "partnerSignUpContent-module-scss-module__QRUmqq__welcomeText",
  "zoomIn": "partnerSignUpContent-module-scss-module__QRUmqq__zoomIn",
  "zoomOut": "partnerSignUpContent-module-scss-module__QRUmqq__zoomOut",
});
